import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../i18n/LanguageContext';
import { CUSTOMER_PORTAL_URL } from '../config';

const inputCls = "w-full rounded-xl border border-[#10282C]/12 bg-white px-4 py-3 text-[14px] text-[#10282C] outline-none focus:border-[#00918F] placeholder:text-[#10282C]/30";

export default function Login() {
  const { t } = useLang();
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // No backend on this site — hand off to the customer portal.
    const params = new URLSearchParams({ email });
    window.location.href = `${CUSTOMER_PORTAL_URL}/login?${params.toString()}`;
  };

  return (
    <div className="min-h-screen bg-[#F6F8F7]">
      <section className="bg-[#10282C] grain relative overflow-hidden pt-32 pb-40">
        <div className="absolute inset-0 dot-grid opacity-50" />
        <div className="relative z-10 max-w-2xl mx-auto px-5 sm:px-8 text-center">
          <h1 className="font-display font-bold text-white text-3xl sm:text-4xl tracking-tight">{t('auth.loginTitle')}</h1>
          <p className="mt-4 text-[15px] text-white/55">{t('auth.loginSub')}</p>
        </div>
      </section>
      <div className="max-w-md mx-auto px-5 sm:px-8 -mt-24 relative z-20 pb-28">
        <form
          onSubmit={handleSubmit}
          className="rounded-3xl bg-white border border-[#10282C]/8 shadow-[0_32px_80px_-32px_rgba(16,40,44,0.3)] p-8 sm:p-10 space-y-4"
          data-testid="login-form"
        >
          <div>
            <label className="text-[12.5px] font-semibold text-[#10282C]/70">{t('auth.email')}</label>
            <input data-testid="login-input-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={`mt-1.5 ${inputCls}`} style={{ transition: 'border-color 0.2s ease' }} />
          </div>
          <div>
            <label className="text-[12.5px] font-semibold text-[#10282C]/70">{t('auth.password')}</label>
            <input data-testid="login-input-password" required type="password" className={`mt-1.5 ${inputCls}`} style={{ transition: 'border-color 0.2s ease' }} />
          </div>
          <button data-testid="login-submit-btn" type="submit" className="btn-teal w-full py-3.5 rounded-full text-[15px] font-semibold">
            {t('auth.signIn')}
          </button>
          <p className="text-center text-[13px] text-[#10282C]/50">
            {t('auth.noAccount')}{' '}
            <Link to="/signup" data-testid="login-signup-link" className="text-[#00918F] font-semibold">{t('auth.signUp')}</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
